module.exports = __webpack_public_path__ + "img/9788994210612.a1dbdc85.jpg";